<template lang="pug">
    div.servicos-online-cidadao.mx-6.pa-4
        h2.mx-6.mt-3 {{ $t('servicos-online-cidadao') }}
        div.row
            div.col-xs-12.col-sm-4(
                v-for="(servico, key) in servicos"
                :key="key"
            )
                v-card#card-servico-online.mx-6.pa-4(
                    height="210"
                )
                    v-icon.pb-6(
                        size="40"
                        color="black"
                    ) {{ servico.icone }}
                    p {{ servico.nome }}
                    a#link-card-servico(
                        :href="servico.link"
                        target="__blank"
                    )
                        p.text-uppercase.font-weight-bold {{ servico.link_msg }}
        
            div.col-12.text-right
                v-btn.float-right.mr-6.mt-4(
                    dark
                    color="#C4170C"
                    :href="link_ver_mais"
                    target="__blank"
                ) {{ $t('ver-mais') }}
</template>

<script lnag="ts">
import { Vue, Component } from "vue-property-decorator";

@Component({
  data: () => ({
    link_ver_mais: "https://sim.marica.rj.gov.br/",
    servicos: [
      {
        icone: "people",
        nome: "Cadastro de cidadão",
        link: "https://sim.marica.rj.gov.br/cadastroCGM",
        link_msg: "Acessar Portal SIM"
      },
      {
        icone: "people",
        nome: "Cadastro de Quitação de ITBI",
        link: "https://sim.marica.rj.gov.br/certidaoITBI",
        link_msg: "Acessar Portal SIM"
      },
      {
        icone: "people",
        nome: "Cadastro de Numeração Predial Oficial",
        link: "https://sim.marica.rj.gov.br/certidaoNumeroPorta",
        link_msg: "Acessar Portal SIM"
      }
    ]
  })
})
export default class ServicosOnline extends Vue {
    mounted() {
        this.$ga.page('/agendar-servico')
    }
}
</script>

<style lang="css">
#card-servico {
  position: relative;
}
#link-card-servico p {
  position: absolute;
  bottom: 0;
  color: black;
}
</style>
